import { Injectable, signal, effect } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {
  isSidebarMinimized = signal<boolean>(false);
  isMobileSidebarOpen = signal<boolean>(false);

  constructor() {
    effect(() => {
      const minimized = this.isSidebarMinimized();
      if (minimized) {
        document.body.classList.add('sidebar-minimized');
      } else {
        document.body.classList.remove('sidebar-minimized');
      }
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 300);
    });
  }

  toggleDesktopSidebar() {
    this.isSidebarMinimized.update(v => !v);
  }

  toggleMobileSidebar() {
    this.isMobileSidebarOpen.update(v => !v);
  }

  closeMobileSidebar() {
    this.isMobileSidebarOpen.set(false);
  }
}
